import React, { useMemo } from 'react';
import { Popover } from '@mantine/core';
import { Button, Text, Progress } from '@shakkerai/pro-components';
import { Icon } from '@shakkerai/components';
import styles from './index.modules.scss';
import { translate } from '@shakkerai/util-i18n';

export const StoragePopover = (props) => {
  const { children, total, used } = props;

  const precent = useMemo(() => {
    return Math.ceil((used * 100) / total);
  }, [total, used]);

  const isFull = useMemo(() => {
    return precent >= 100;
  }, [precent]);

  const isReachWarningLimit = useMemo(() => {
    return precent >= 90 && precent < 100;
  }, [precent]);

  const renderConfig = useMemo(() => {
    if (isFull) {
      return {
        progressStyle: 'error',
        tip1: translate('history_storagefull'),
        tip2: translate('history_storagefullalert'),
      };
    } else if (isReachWarningLimit) {
      return {
        progressStyle: 'warning',
        tip1: translate('history_useup1'),
        tip2: translate('history_useup2'),
      };
    } else {
      return {
        progressStyle: 'default',
        tip1: '',
        tip2: '',
      };
    }
  }, [isFull, isReachWarningLimit]);

  return (
    <Popover width={264} position="bottom-start" withArrow={false} shadow="md">
      <Popover.Target>{children}</Popover.Target>
      <Popover.Dropdown className={styles.panelC} data-role="gen-history-trigger">
        <Text color="var(--color-primary-font)">
          {translate('storage')}: {precent}%
        </Text>
        <Progress value={precent} className={`${styles.progress}`} type={renderConfig.progressStyle} />
        <div className={styles.storage}>
          <Text size={12} color="var(--color-input-normal-color)" className={styles.input}>
            {used}/{total} {translate('history_limit')}
          </Text>
          {false && (
            <Button size={11} className={styles.button} color="#FFDEAD">
              Expansion
            </Button>
          )}
        </div>

        {(isFull || isReachWarningLimit) && (
          <div className={styles.warningTips}>
            <Icon className={`icon-proExclude ${styles.icon}`} color="var(--color-fifth)" fontSize={12}></Icon>
            <div className={styles.content}>
              <Text size="11" color="var(--color-primary-font)">
                {renderConfig.tip1}
              </Text>
              <Text size="11" color="var(--color-subsidiary-font)" className="mt-1">
                {renderConfig.tip2}
              </Text>
            </div>
          </div>
        )}
      </Popover.Dropdown>
    </Popover>
  );
};
